export const isRtl = document.documentElement.getAttribute("dir") === "rtl";
